var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.idFoSelection
    ? _c(
        "div",
        {
          staticClass: "selection",
          class: [
            _vm.tab,
            _vm.interRelatedTeaser
              ? "interRelated-" + _vm.interRelatedTeaser
              : "",
            {
              isLive: _vm.isLive,
              priceUp: _vm.priceUp,
              priceDown: _vm.priceDown,
              hcpUp: _vm.hcpUp,
              hcpDown: _vm.hcpDown,
              isClosed: _vm.isClosed,
              isSuspended: _vm.isSuspended,
              edit: _vm.currentBetSlipState == 0,
              review: _vm.currentBetSlipState == 1,
              optedOut: !_vm.optedIn[_vm.id],
              oddsBust: _vm.pricetype === "XP",
              interRelated: _vm.interRelatedTeaser,
              mixedTeasers: _vm.mixedTeasers
            }
          ]
        },
        [
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column column-left" },
              [
                _vm.showCheckbox === true
                  ? _c("v-checkbox", {
                      attrs: {
                        type: "checkbox",
                        id: _vm.id.toString(),
                        value: _vm.optedIn[_vm.id],
                        disabled: _vm.currentBetSlipState >= 1
                      },
                      on: {
                        change: function($event) {
                          return _vm.updateOptedIn(_vm.id)
                        }
                      },
                      model: {
                        value: _vm.optedIn[_vm.id],
                        callback: function($$v) {
                          _vm.$set(_vm.optedIn, _vm.id, $$v)
                        },
                        expression: "optedIn[id]"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showCheckbox
                  ? [
                      _vm.mixedTeasers
                        ? _c("icon", {
                            attrs: {
                              colorName: "blue",
                              name:
                                "icon-" +
                                (_vm.selection.idfosporttype &&
                                  _vm.selection.idfosporttype
                                    .split(" ")
                                    .join(""))
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.mixedTeasers
                        ? _c("span", { staticClass: "igt-icon" })
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            !_vm.betslipLayout2
              ? _c(
                  "div",
                  {
                    staticClass: "column column-right",
                    on: {
                      click: function($event) {
                        return _vm.toggleOptedIn()
                      }
                    }
                  },
                  [
                    _c("label", { attrs: { for: _vm.id } }, [
                      _c("div", { staticClass: "selection-data" }, [
                        _c("div", { staticClass: "event-name-inner" }, [
                          _c(
                            "div",
                            {
                              staticClass: "event-name",
                              class: { mixedTeasers: _vm.mixedTeasers }
                            },
                            [
                              _c("span", { staticClass: "eventname" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.wbr(_vm.eventName, 0)))
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.wbr(_vm.eventName, 1)))
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.isLive
                                ? _c("span", { staticClass: "isLive" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.selection.isLive")
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "selection-name" }, [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.selectionName) +
                                "\n              "
                            ),
                            _vm.selection &&
                            typeof _vm.selection.currenthandicap == "number"
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "currenthandicap",
                                    class: [
                                      { hcpUp: _vm.hcpUp },
                                      { hcpDown: _vm.hcpDown }
                                    ]
                                  },
                                  [_c("span", [_vm._v(_vm._s(_vm.handicap))])]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "teaser-hcp float-right",
                              class: "pricetype-" + _vm.pricetype
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "currenthandicapT",
                                  class: [
                                    { hcpUp: _vm.hcpUp },
                                    { hcpDown: _vm.hcpDown }
                                  ]
                                },
                                [
                                  _vm._v(
                                    "\n                 " +
                                      _vm._s(_vm.teaserHCP) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "market-name" }, [
                          _vm._v(_vm._s(_vm.marketName))
                        ]),
                        _vm._v(" "),
                        _vm.showEventTsStart
                          ? _c(
                              "div",
                              { staticClass: "eventTsStart market-name" },
                              [
                                _vm.showEventTsStart
                                  ? _c("ts-start", {
                                      attrs: {
                                        tsstart:
                                          _vm.market.tsstartWithOffset ||
                                          _vm.market.tsstart
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.betslipLayout2
              ? _c(
                  "div",
                  {
                    staticClass: "column column-right",
                    on: {
                      click: function($event) {
                        return _vm.toggleOptedIn()
                      }
                    }
                  },
                  [
                    _c("label", { attrs: { for: _vm.id } }, [
                      _c("div", { staticClass: "selection-data" }, [
                        _c("div", { staticClass: "selection-name" }, [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.selectionName) +
                                "\n              "
                            ),
                            _vm.selection &&
                            typeof _vm.selection.currenthandicap == "number"
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "currenthandicap",
                                    class: [
                                      { hcpUp: _vm.hcpUp },
                                      { hcpDown: _vm.hcpDown }
                                    ]
                                  },
                                  [_c("span", [_vm._v(_vm._s(_vm.handicap))])]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "teaser-hcp float-right",
                              class: "pricetype-" + _vm.pricetype
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "currenthandicapT",
                                  class: [
                                    { hcpUp: _vm.hcpUp },
                                    { hcpDown: _vm.hcpDown }
                                  ]
                                },
                                [
                                  _vm._v(
                                    "\n                 " +
                                      _vm._s(_vm.teaserHCP) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "event-name-inner" }, [
                          _c(
                            "div",
                            {
                              staticClass: "event-name",
                              class: { mixedTeasers: _vm.mixedTeasers }
                            },
                            [
                              _c("span", { staticClass: "eventname" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.wbr(_vm.eventName, 0)))
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.wbr(_vm.eventName, 1)))
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.isLive
                                ? _c("span", { staticClass: "isLive" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.selection.isLive")
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "market-name" }, [
                          _vm._v(_vm._s(_vm.marketName))
                        ]),
                        _vm._v(" "),
                        _vm.showEventTsStart
                          ? _c(
                              "div",
                              { staticClass: "eventTsStart market-name" },
                              [
                                _vm.showEventTsStart
                                  ? _c("ts-start", {
                                      attrs: {
                                        tsstart:
                                          _vm.market.tsstartWithOffset ||
                                          _vm.market.tsstart
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e3668a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3668a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/selections/selectionTeaser.vue
// module id = null
// module chunks = 